import Api from "./baseApi";
export default {
  searchStockGroup: stockGroup => {
    let url = "/api/stockGroups?v=1";
    if (stockGroup.search) url += `&q=${stockGroup.search}`;
    if (stockGroup.state > -1) url += `&state=${stockGroup.state}`;
    return Api.get(url);
  },
  getstockGroups: () => Api.get("/api/stockGroups"),
  getStockGroup: id => Api.get(`/api/stockGroups/${id}`),
  putStockGroup: stockGroup => Api.put(`/api/stockGroups/${stockGroup.id}`, stockGroup),
  deleteStockGroup: stockGroup => Api.delete(`/api/stockGroups/${stockGroup.id}`, stockGroup),
  postStockGroup: stockGroup => Api.post(`/api/stockGroups`, stockGroup),
  buystockGroups(stockGroups, cb, errorCb) {
    setTimeout(() => {
      // simulate random checkout failure.
      Math.random() > 0.5 || navigator.userAgent.indexOf("PhantomJS") > -1
        ? cb()
        : errorCb();
    }, 100);
  }
};
